import { ICardUIExtensionContext, ICardModel, IControlViewModel, IFormViewModel } from 'tessa/ui/cards';
import { CardGetFileContentRequest, CardRequest, CardService } from 'tessa/cards/service';
import { createTypedField, DotNetType, Guid, hasFlag, Visibility } from 'tessa/platform';
import { showNotEmpty, showError, showMessage } from 'tessa/ui';
import { GridViewModel, ControlViewModelBase, AutoCompleteEntryViewModel, TextBoxViewModel, GridRowAction, GridRowEventArgs } from 'tessa/ui/cards/controls';
import { CdRequestTypes } from '../Helpers/CdRequestTypes';
import { CdCommonHelper } from '../Helpers/CdCommonHelper';
import { CardRowState, CardSection, CardRow, Card, CardPermissionFlags, CardFileState, CardSectionType, CardStoreMode, CardFieldChangedEventArgs } from 'tessa/cards';
import { CdFdTaskTypes } from '../Helpers/CdFdTaskTypes';
import { ChFileCategories } from 'src/pkScripts/Helpers/ChFileCategories';
import { CdGeneralDocumentationClientHelper } from '../Helpers/Cards/CdGeneralDocumentationClientHelper';
import { LocalizationManager } from 'tessa/localization';
import { PkOutgoingKinds } from '../../pkScripts/Helpers/PkOutgoingKinds';
import { IUserSession } from 'common/utility/userSession';
import { CdDocStates } from '../Helpers/CdDocStates';
import { DocumentSections } from "../../pkScripts/Helpers/Enums/DocumentSections";

export class CdUIHelper {

    public static async CheckPartnerInPerimeterAsync(partnerExternalID: number | null, аccreditationPerimetrName: string, everBeen: boolean = false) {

        if (!partnerExternalID) {
            return false;
        }

        const request = new CardRequest();
        request.requestType = CdRequestTypes.CheckPartnerInPerimeter;
        request.info["PartnerExternalID"] = createTypedField(partnerExternalID, DotNetType.Int64);
        request.info["AccreditationPerimetrName"] = createTypedField(аccreditationPerimetrName, DotNetType.String);
        request.info["EverBeen"] = createTypedField(everBeen, DotNetType.Boolean);

        const response = await CardService.instance.request(request);
        if (!response.validationResult.isSuccessful)
            return false;

        let error = response.info.Error?.$value;
        if (error) {
            await showError(error);
            return false;
        }

        let res: boolean = response.info.IsPartnerInPerimeter.$value;
        return res;

    }


    public static SetReadOnlyToControls(readOnlyValue: boolean, ...controls: IControlViewModel[]) {
        controls.forEach(control => {
            if (control != null && control.isReadOnly !== readOnlyValue) control.isReadOnly = readOnlyValue;
        });
    }

    /** Установка видимости контрола */
    public static SetConrolVisibility(control: IControlViewModel, isVisible: boolean) {
        const visibility: Visibility = isVisible ? Visibility.Visible : Visibility.Collapsed;
        control.controlVisibility = visibility;
    }

    /** Скрытие вкладок из карточки. */
    public static HideTabs(
        model: ICardModel,
        ...tabCaptions: string[]) {
        if (tabCaptions == null || tabCaptions.length == 0) {
            return;
        }

        for (var i = model.forms.length - 1; i >= 0; i--) {
            const form = model.forms[i];
            if (!tabCaptions.some(x => x == LocalizationManager.instance.localize(form.tabCaption))) {
                continue;
            }

            form.visibility = Visibility.Collapsed;
        }
    }

    // Связка предприятие-подразделения-автор
    public static GroupEnterpriseLogic(context: ICardUIExtensionContext) {
        let ArContractsUser = context.model.card.sections.tryGet('ArContractsUser');
        if (ArContractsUser == null) return;

        ArContractsUser.fields.fieldChanged.add(async e => {
            if (e.fieldName == "AuthorID") {
                if (e.fieldValue != null) {
                    const request = new CardRequest();
                    request.requestType = CdRequestTypes.GetAuthorDepartment;
                    request.info["AuthorID"] = createTypedField(e.fieldValue, DotNetType.Guid);

                    const response = await CardService.instance.request(request);

                    await showNotEmpty(response.validationResult.build());
                    if (response.validationResult.isSuccessful) {

                        if (ArContractsUser == null) return;
                        CdCommonHelper.SetFieldToSection(ArContractsUser, "OrganizationID", response.info.OrganizationID);
                        CdCommonHelper.SetFieldToSection(ArContractsUser, "OrganizationName", response.info.OrganizationName);
                        CdCommonHelper.SetFieldToSection(ArContractsUser, "OrganizationExternalID", response.info.OrganizationExternalID);
                        CdCommonHelper.SetFieldToSection(ArContractsUser, "OrganizationGuid1C", response.info.OrganizationGuid1C);
                        CdCommonHelper.SetFieldToSection(ArContractsUser, "AuthorDepartmentID", response.info.AuthorDepartmentID);
                        CdCommonHelper.SetFieldToSection(ArContractsUser, "AuthorDepartmentName", response.info.AuthorDepartmentName);
                    }

                } else {
                    if (ArContractsUser == null) return;
                    ArContractsUser.fields.set('OrganizationID', null);
                    ArContractsUser.fields.set('OrganizationExternalID', null);
                    ArContractsUser.fields.set('OrganizationName', null);
                    ArContractsUser.fields.set('OrganizationGuid1C', null);
                    ArContractsUser.fields.set('AuthorDepartmentID', null);
                    ArContractsUser.fields.set('AuthorDepartmentName', null);
                }
            }
            if (e.fieldName == "AuthorDepartmentID") {
                if (e.fieldValue != null) {
                    if (ArContractsUser == null) return;
                    let AuthorID = ArContractsUser.fields.tryGet("AuthorID");
                    if (AuthorID == null) return;
                    const request = new CardRequest();
                    request.requestType = CdRequestTypes.GetAuthorDepartment;
                    request.info["AuthorID"] = createTypedField(AuthorID, DotNetType.Guid);
                    request.info["AuthorDepartmentID"] = createTypedField(e.fieldValue, DotNetType.Guid);
                    const response = await CardService.instance.request(request);

                    await showNotEmpty(response.validationResult.build());
                    if (response.validationResult.isSuccessful) {

                        if (ArContractsUser == null) return;
                        CdCommonHelper.SetFieldToSection(ArContractsUser, "OrganizationID", response.info.OrganizationID);
                        CdCommonHelper.SetFieldToSection(ArContractsUser, "OrganizationName", response.info.OrganizationName);
                        CdCommonHelper.SetFieldToSection(ArContractsUser, "OrganizationExternalID", response.info.OrganizationExternalID);
                        CdCommonHelper.SetFieldToSection(ArContractsUser, "OrganizationGuid1C", response.info.OrganizationGuid1C);
                    }

                } else {
                    if (ArContractsUser == null) return;
                    ArContractsUser.fields.set('OrganizationID', null);
                    ArContractsUser.fields.set('OrganizationExternalID', null);
                    ArContractsUser.fields.set('OrganizationName', null);
                    ArContractsUser.fields.set('OrganizationGuid1C', null);
                }
            }
        });

    }

    public static CheckCanEditTechnicalArticle(card: Card, row: CardRow) {
        let arContractPartners = card.sections.tryGet('ArContractPartners');
        let arContractsUser = card.sections.tryGet('ArContractsUser');
        if (arContractPartners == null || arContractPartners.rows == null || arContractsUser == null) return false;
        let partner = arContractPartners.rows.find(x =>
            x.state != CardRowState.Deleted
            && x.get("RoleID") != null
            && x.get("PartnerAutomated") != null
            && x.get("RoleID") == 0
            && x.get("PartnerAutomated") == true
        );
        if (row.get("BasedOn") == null
            && partner == null) {
            return true;
        }
        return false;
    }

    public static InitializeContractTableObjects(context: ICardUIExtensionContext, isTransferToUSReadonlyFields: boolean, session: IUserSession) {
        const objects = context.model.controls.get('ContractArticleIdp') as GridViewModel;
        const isProhibitModify = hasFlag(context.model.card.permissions.resolver
            .getSectionPermissions("ArContractArticleIdp"), CardPermissionFlags.ProhibitModify);
        const fieldPermissions = context.model.card.permissions.sections.tryGet("ArContractArticleIdp")?.fieldPermissions;
        if ((!objects || isProhibitModify) && !fieldPermissions) {
            this.AllowEditESUDDocs(context, session, DocumentSections.ContractArticleIdp);
            return;
        }

        const isAmountAllowModify = fieldPermissions?.tryGet("Amount")?.$value == CardPermissionFlags.AllowModify;
        const isAmountAllAllowModify = fieldPermissions?.tryGet("AmountAll")?.$value == CardPermissionFlags.AllowModify;
        const isCostItemAllowModify = fieldPermissions?.tryGet("CostItemID")?.$value == CardPermissionFlags.AllowModify;
        const isObjectAllowModify = fieldPermissions?.tryGet("ObjectID")?.$value == CardPermissionFlags.AllowModify;
        const isPaymentTermAllowModify = fieldPermissions?.tryGet("PaymentTerm")?.$value == CardPermissionFlags.AllowModify;
        const isProjectAllowModify = fieldPermissions?.tryGet("ProjectID")?.$value == CardPermissionFlags.AllowModify;
        const isStageNameAllowModify = fieldPermissions?.tryGet("StageName")?.$value == CardPermissionFlags.AllowModify;
        const isVatRateAllowModify = fieldPermissions?.tryGet("VatRateID")?.$value == CardPermissionFlags.AllowModify;
        const isPercentPrepaymentAllowModify = fieldPermissions?.tryGet("PercentPrepayment")?.$value == CardPermissionFlags.AllowModify;
        const objectList = context.model.card.sections.tryGet('ArContractArticleIdp');
        if (objectList == null) return;
        objects.rowInitializing.add(e => {
            if (e.rowModel!.controls.get('Object') == null) {
                return;
            }


            let objectID = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "Object");
            let project = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "Project");
            let residentialComplex = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "ResidentialComplex");
            let stageName = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "StageNameArticleControl");
            let costItem = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "CostItem");
            let amount = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "AmountArticleControl");
            let amountAll = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "AmountAllArticleControl");
            let paymentTerm = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "PaymentTermArticleControl");
            let percentPrepayment = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "PercentPrepaymentArticleControl");
            let vatRate = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "VatRateCommon");

            if (context.model.card.storeMode != CardStoreMode.Insert) {
                CdUIHelper.SetReadOnlyToControls(!isObjectAllowModify, objectID!);
                CdUIHelper.SetReadOnlyToControls(!isAmountAllowModify, amount!);
                CdUIHelper.SetReadOnlyToControls(!isProjectAllowModify, project!);
                CdUIHelper.SetReadOnlyToControls(!isStageNameAllowModify, stageName!);
                CdUIHelper.SetReadOnlyToControls(!isCostItemAllowModify, costItem!);
                CdUIHelper.SetReadOnlyToControls(!isAmountAllAllowModify, amountAll!);
                CdUIHelper.SetReadOnlyToControls(!isPaymentTermAllowModify, paymentTerm!);
                CdUIHelper.SetReadOnlyToControls(!isPercentPrepaymentAllowModify, percentPrepayment!);
                CdUIHelper.SetReadOnlyToControls(!isVatRateAllowModify, vatRate!);
            }
            if ((context.model.card.permissions.cardPermissions & CardPermissionFlags.AllowModify) == 0)
                return;
            let canEdit = true;
            if (e.row.get("AutoGenerated") != null && e.row.get("AutoGenerated") == true) {
                canEdit = this.CheckCanEditTechnicalArticle(context.model.card, e.row);
            }

            if (canEdit) {
                if (e.row.tryGet("ObjectID") != null) {
                    CdUIHelper.SetReadOnlyToControls(false, objectID!);
                    CdUIHelper.SetReadOnlyToControls(true, residentialComplex!, project!);
                }
                else {
                    CdUIHelper.SetReadOnlyToControls(false, objectID!, residentialComplex!, project!);
                }
            }
            e.row.fieldChanged.add(async e2 => {
                if (e2.fieldName === "ObjectID") {

                    CdUIHelper.SetReadOnlyToControls(true, objectID!, residentialComplex!, project!);

                    if (e2.fieldValue == null) {

                        e.row.set("ProjectID", null);
                        e.row.set("ProjectName", null);
                        e.row.set("ProjectProjectID", null);
                        e.row.set("ObjectName", null);
                        e.row.set("ObjectObjectID", null);
                        e.row.set("ObjectCode1c", null);
                        e.row.set("ObjectNumber", null);
                        e.row.set("ResidentialComplexID", null);
                        e.row.set("ResidentialComplexName", null);

                        CdUIHelper.SetReadOnlyToControls(false, objectID!, residentialComplex!, project!);
                    }
                    else {
                        let objectId = e2.fieldValue;

                        const request = new CardRequest();
                        request.requestType = CdRequestTypes.GetRegionCityAndProjectByObject;
                        request.info["ObjectId"] = createTypedField(objectId, DotNetType.Guid);

                        const response = await CardService.instance.request(request);

                        await showNotEmpty(response.validationResult.build());
                        if (!response.validationResult.isSuccessful) {
                            e.row.set("ProjectID", null);
                            e.row.set("ProjectName", null);
                            e.row.set("ProjectProjectID", null);
                            e.row.set("ObjectName", null);
                            e.row.set("ObjectObjectID", null);
                            e.row.set("ObjectCode1c", null);
                            e.row.set("ObjectNumber", null);
                            e.row.set("ResidentialComplexID", null);
                            e.row.set("ResidentialComplexName", null);

                            CdUIHelper.SetReadOnlyToControls(false, residentialComplex!, project!);
                        }
                        else {
                            CdCommonHelper.SetFieldToRow(e.row, "ProjectID", response.info.ProjectID);
                            CdCommonHelper.SetFieldToRow(e.row, "ProjectName", response.info.ProjectName);
                            CdCommonHelper.SetFieldToRow(e.row, "ObjectName", response.info.ObjectName);
                            CdCommonHelper.SetFieldToRow(e.row, "ObjectObjectID", response.info.ObjectExtID);
                            CdCommonHelper.SetFieldToRow(e.row, "ObjectCode1c", response.info.Guid1C);
                            CdCommonHelper.SetFieldToRow(e.row, "ObjectNumber", response.info.ObjectNumber);
                            CdCommonHelper.SetFieldToRow(e.row, "ResidentialComplexID", response.info.ResidentialComplexID);
                            CdCommonHelper.SetFieldToRow(e.row, "ResidentialComplexName", response.info.ResidentialComplexName);

                            CdUIHelper.SetReadOnlyToControls(false, objectID!);
                        }
                    }
                }
                else if (e2.fieldName === "ResidentialComplexID") {
                    let projectID = e.row.tryGetField("ProjectID");
                    if (projectID == null) {
                        const response = await CdUIHelper.RequestByResidentialComplexOrProjectWithNoAvailable(e2.fieldValue, "ResidentialComplexID");
                        if (response != null && response.info != null && response.info.ProjectID) {
                            projectID = response.info.ProjectID;
                            CdCommonHelper.SetFieldToRow(e.row, "ProjectID", response.info.ProjectID);
                            CdCommonHelper.SetFieldToRow(e.row, "ProjectName", response.info.ProjectName);
                        }
                    }

                    if (e2.fieldValue !== null) {
                        setTimeout(this.SetAutoCompleteEntryValueIfOneAsync, 100, objectID!, e.row, "ObjectID", "ObjectName");
                    }

                }
                else if (e2.fieldName === "ProjectID") {
                    let residentialComplexID = e.row.tryGetField('ResidentialComplexID');
                    if (residentialComplexID == null) {
                        const response = await CdUIHelper.RequestByResidentialComplexOrProjectWithNoAvailable(e2.fieldValue, "ProjectID");
                        if (response != null && response.info != null && response.info.ResidentialComplexID) {
                            residentialComplexID = response.info.ResidentialComplexID;
                            CdCommonHelper.SetFieldToRow(e.row, "ResidentialComplexID", response.info.ResidentialComplexID);
                            CdCommonHelper.SetFieldToRow(e.row, "ResidentialComplexName", response.info.ResidentialComplexName);
                        }
                    }

                    if (e2.fieldValue !== null) {
                        setTimeout(this.SetAutoCompleteEntryValueIfOneAsync, 100, objectID!, e.row, "ObjectID", "ObjectName");
                    }
                }
            });

            this.AllowEditESUDDocs(context, session, DocumentSections.ContractArticleIdp);

            // После передачи в УС нужно запретить
            if (e.action == GridRowAction.Opening) {
                if (isTransferToUSReadonlyFields && !this.IsRowCreatedAfterTransferToUS(e.row, e.cardModel?.card)) {
                    e.rowModel?.controlsBag.forEach((control) => {
                        control.isReadOnly = true;
                    });
                }
            }
        });
    }

    public static IsRowCreatedAfterTransferToUS(row: CardRow, card: Card) {
        let section = card.sections.tryGet('ArContractsUser');
        if (section != null && row != null) {
            let transferDate = section.fields.tryGet('TransferToUSDate');
            let createdDate = row.tryGet('Created');
            return transferDate == null && createdDate == null || transferDate < createdDate;
        }
        return true;
    }

    public static InitializeTableObjects(context: ICardUIExtensionContext) {
        const objects = context.model.controls.get('Objects') as GridViewModel;
        const isProhibitModify = hasFlag(context.model.card.permissions.resolver
            .getSectionPermissions("PkObjectList"), CardPermissionFlags.ProhibitModify);
        if (!objects || isProhibitModify) return;
        const control = context.model.controls.get('RealEstate');
        if (control) control.isReadOnly = true;

        const objectList = context.model.card.sections.tryGet('PkObjectList');
        if (objectList == null) return;
        let documentCommonInfoSection = context.card.sections.tryGet("DocumentCommonInfo");
        let pkoSection = context.model.card.sections.tryGet('PkOutgoing');
        //if (pkoSection != null && pkoSection.fields.tryGet('TypeID') == PkOutgoingKinds.ClaimId) 
        //{
        //    objects.isReadOnly = true;
        //}
        objects.rowInvoked.add(e => {
            let card = context.model.card

            let objectsSection = e.cardModel.card.sections.tryGet("PkObjectList");
            let pkOutgoingVirtual = context.card.sections.tryGet("PkOutgoingVirtual");

            if (objectsSection && pkOutgoingVirtual) {
                const objsList = objectsSection.rows.filter(x => x.state !== CardRowState.Deleted && ((e.action == GridRowAction.Deleting && x.rowId != e.row.rowId) || e.action != GridRowAction.Deleting));
                let objectIds: string = '';
                if (objsList && !(objsList.length == 0)) {
                    objectIds = objsList
                        .map(r => '"' + r.getField("ObjectID")?.$value + '"')
                        .filter((v, i, a) => a.indexOf(v) == i)
                        .join(',');
                    pkOutgoingVirtual.fields.set('ObjectsJsonForView', (!objectIds || objectIds.length === 0) ? null : '[' + objectIds + ']', DotNetType.String);
                } else {
                    pkOutgoingVirtual.fields.set('ObjectsJsonForView', null, DotNetType.String);
                }
            }
            if (pkoSection && documentCommonInfoSection && objectsSection && pkoSection.fields.tryGet('TypeID') == PkOutgoingKinds.ClaimId) {
                let claimContractControl = context.model.controls.get('ClaimContractControl');
                if (claimContractControl != null) {
                    const isOneObject = objectsSection.rows.filter(x => x.state !== CardRowState.Deleted && ((e.action == GridRowAction.Deleting && x.rowId != e.row.rowId) || e.action != GridRowAction.Deleting)).length == 1;
                    const isDepartmentEmpty = documentCommonInfoSection?.fields.tryGet("DepartmentID") == null;
                    claimContractControl.isReadOnly = !isOneObject || pkoSection.fields.tryGet("PartnerKCKExternalID") == null || isDepartmentEmpty;
                }
            }
            if (e.action == GridRowAction.Deleting && card != null) {
                if (pkoSection) {
                    pkoSection?.fields.set("ContractID", null);
                    pkoSection?.fields.set("ContractExtID", null);
                    pkoSection?.fields.set("ContractNumberVirtual", null);
                    pkoSection?.fields.set("ClaimAmount", null);
                    pkoSection?.fields.set("AdditionalEmailsForPartners", null);
                }
                let claimPerformersSection = card.sections.tryGet("PkOutgoingClaimPerformers");
                if (!claimPerformersSection) {
                    return;
                }

                if (card.storeMode == CardStoreMode.Update) {


                    let parentRows = claimPerformersSection!.rows;
                    // Удаляем родителя только если все дочерние удалены.
                    parentRows!.forEach(prow => {

                        if (prow.state == CardRowState.Inserted) {
                            claimPerformersSection?.rows.remove(prow);
                        }
                        else {
                            prow.state = CardRowState.Deleted;
                        }

                    });


                } else if (card.storeMode == CardStoreMode.Insert) {


                    let parentRows = claimPerformersSection!.rows;
                    // Удаляем родителя только если все дочерние удалены.
                    parentRows!.forEach(prow => {

                        claimPerformersSection?.rows.remove(prow);

                    });
                }
            }
        });
        objects.rowEditorClosing.add(async e => {
            let objectControlmodel = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "Object");
            let objectid = e.row.tryGetField('ObjectID');
            if (objectid) {
                let message = 'Выбранный объект передан в систему BuildDocs.\n' +
                    'Создание исполнительной документации для этого объекта недоступно!'
                let islocked = await CdUIHelper.GetBuildDocsLockedState(objectid.$value);
                if (objectControlmodel) {
                    objectControlmodel.hasActiveValidation = islocked;
                    objectControlmodel.validationFunc = () => islocked ? message : null;
                }
                if (islocked === true) {

                    // Сохраняем подписчиков.Такая реализация работает быстрее
                    const fieldChangedSubscribers = Array.from(e.row.fieldChanged.events);

                    // Очищаем все подписчики на событие fieldChanged
                    e.row.fieldChanged.clear();

                    // Очищаем объект без вызова событий
                    e.row.set('ObjectID', null);
                    e.row.set('ObjectName', null);

                    // Восстанавливаем подписчиков на событие fieldChanged
                    for (const subscriber of fieldChangedSubscribers) {
                        e.row.fieldChanged.add(subscriber);
                    }

                    await showError(message);
                    e.cancel = true;
                }
            }
        })
        objects.rowEditorClosed.add(async e => {
            let objectsSection = e.cardModel.card.sections.tryGet("PkObjectList");
            let pkOutgoingVirtual = context.card.sections.tryGet("PkOutgoingVirtual");
            let objectControlmodel = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "Object");
            if (objectsSection && pkOutgoingVirtual) {
                const objsList = objectsSection.rows.filter(x => x.state !== CardRowState.Deleted && ((e.action == GridRowAction.Deleting && x.rowId != e.row.rowId) || e.action != GridRowAction.Deleting));
                let objectIds: string = '';
                if (objsList && !(objsList.length == 0)) {
                    objectIds = objsList
                        .map(r => '"' + r.getField("ObjectID")?.$value + '"')
                        .filter((v, i, a) => a.indexOf(v) == i)
                        .join(',');
                    pkOutgoingVirtual.fields.set('ObjectsJsonForView', (!objectIds || objectIds.length === 0) ? null : '[' + objectIds + ']', DotNetType.String);
                } else {
                    pkOutgoingVirtual.fields.set('ObjectsJsonForView', null, DotNetType.String);
                }
            }
            if (pkoSection && documentCommonInfoSection && objectsSection && pkoSection.fields.tryGet('TypeID') == PkOutgoingKinds.ClaimId) {
                let claimContractControl = context.model.controls.get('ClaimContractControl');
                if (claimContractControl != null) {
                    const isDepartmentEmpty = documentCommonInfoSection?.fields.tryGet("DepartmentID") == null;
                    const isOneObject = objectsSection.rows.filter(x => x.state !== CardRowState.Deleted && ((e.action == GridRowAction.Deleting && x.rowId != e.row.rowId) || e.action != GridRowAction.Deleting)).length == 1;
                    claimContractControl.isReadOnly = !isOneObject || pkoSection.fields.tryGet("PartnerKCKExternalID") == null || isDepartmentEmpty;
                }
            }
            if(objectControlmodel) {
                objectControlmodel.hasActiveValidation = false;
                objectControlmodel.validationFunc = () => null;
            }
        });
        objects.rowAdding.add(async e => {
            if (pkoSection && pkoSection.fields.tryGet('TypeID') === PkOutgoingKinds.ClaimId) {
                let objectsSection = context.card.sections.tryGet("PkObjectList");
                if (objectsSection && objectsSection.rows.filter(x => x.state !== CardRowState.Deleted).length > 0) {
                    showError("Для претензии допустим только один объект в карточке!");
                    e.cancel = true;
                    return;
                }
            }
        });
        objects.rowInitializing.add(e => {
            if (e.rowModel!.controls.get('RealEstate') == null) {
                return;
            }

            let realEstate = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "RealEstate");
            let objectID = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "Object");
            let project = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "Project");
            let residentialComplex = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "ResidentialComplex");
            let section = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "Section");
            let floor = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "Floor");

            if (pkoSection?.fields.tryGet('TypeID') == PkOutgoingKinds.ClaimId) {
                CdUIHelper.SetReadOnlyToControls(true, realEstate!, objectID!, project!, section!, floor!);
            }
            else {
                CdUIHelper.SetReadOnlyToControls(true, realEstate!, objectID!, section!, floor!);
            }
            // все только для чтения
            if ((context.model.card.permissions.cardPermissions & CardPermissionFlags.AllowModify) == 0
            )
                return;

            if (e.row.tryGet("RealEstateID") != null ||
                e.row.tryGet("ObjectID") != null) {
                CdUIHelper.SetReadOnlyToControls(false, realEstate!, objectID!, section!, floor!);
                CdUIHelper.SetReadOnlyToControls(true, residentialComplex!, project!);
            }
            else {
                let residentialComplexID = e.row.tryGetField("ResidentialComplexID");
                let projectID = e.row.tryGetField("ProjectID");

                CdUIHelper.SetReadOnlyToControls(residentialComplexID == null && projectID == null, realEstate!, objectID!, section!, floor!);
            }

            e.row.fieldChanged.add(async e2 => {
                if (pkoSection?.fields.tryGet('TypeID') === PkOutgoingKinds.ClaimId) {
                    await CdUIHelper.OutgoingClaimFieldChanges(e2, objectID, project, e);
                }
                else {
                    await CdUIHelper.CommonFieldChanges(e2, realEstate, objectID, section, floor, residentialComplex, project, e);
                }
                if(objectID && e2.fieldName === 'ObjectID' && e2.fieldValue != null)
                {
                    objectID.hasActiveValidation = false;
                    objectID.validationFunc = () => null;
                }
            });
        });
    }

    /**
     * Возвращает признак того что для объкта запрещено создание исполнительной документации
     * @private
     * @static
     * @param {(any | guid)} fieldValue 
     * @return {(Promise<boolean | any>)} 
     * @memberof CdUIHelper
     * @author Ilchenko
     */
    private static async GetBuildDocsLockedState(fieldValue: any | guid): Promise<boolean | any> {
        if (fieldValue == null) return null;
        const request = new CardRequest();
        request.requestType = CdRequestTypes.IsObjectLockedRequestTypeID;
        request.info['ObjectID'] = createTypedField(fieldValue, DotNetType.Guid);
        const response = await CardService.instance.request(request);

        await showNotEmpty(response.validationResult.build());

        if (response.validationResult.isSuccessful) {
            return response.info.IsLocked?.$value;
        }
        return null;
    }

    private static async CommonFieldChanges(e2: CardFieldChangedEventArgs, realEstate: IControlViewModel | null, objectID: IControlViewModel | null, section: IControlViewModel | null, floor: IControlViewModel | null, residentialComplex: IControlViewModel | null, project: IControlViewModel | null, e: GridRowEventArgs) {
        if (e2.fieldName === "ObjectID") {

            CdUIHelper.SetReadOnlyToControls(true, realEstate!, objectID!, section!, floor!, residentialComplex!, project!);

            if (e2.fieldValue == null) {
                e.row.set("RegionID", null);
                e.row.set("RegionName", null);
                e.row.set("CityID", null);
                e.row.set("CityName", null);
                e.row.set("ProjectID", null);
                e.row.set("ProjectName", null);
                e.row.set("LivingComplex", null);
                e.row.set("ObjectName", null);
                e.row.set("AddressPost", null);
                e.row.set("RealEstateName", null);
                e.row.set("ResidentialComplexID", null);
                e.row.set("ResidentialComplexName", null);
                e.row.set("Guid1C", null);
                e.row.set("SectionID", null);
                e.row.set("SectionNumber", null);
                e.row.set("FloorID", null);
                e.row.set("FloorNumber", null);

                CdUIHelper.SetReadOnlyToControls(false, residentialComplex!, project!);
            }
            else {
                let objectId = e2.fieldValue;

                const request = new CardRequest();
                request.requestType = CdRequestTypes.GetRegionCityAndProjectByObject;
                request.info["ObjectId"] = createTypedField(objectId, DotNetType.Guid);

                const response = await CardService.instance.request(request);

                await showNotEmpty(response.validationResult.build());
                if (!response.validationResult.isSuccessful) {
                    e.row.set("RegionID", null);
                    e.row.set("RegionName", null);
                    e.row.set("CityID", null);
                    e.row.set("CityName", null);
                    e.row.set("ProjectID", null);
                    e.row.set("ProjectName", null);
                    e.row.set("LivingComplex", null);
                    e.row.set("ObjectName", null);
                    e.row.set("AddressPost", null);
                    e.row.set("RealEstateName", null);
                    e.row.set("ResidentialComplexID", null);
                    e.row.set("ResidentialComplexName", null);
                    e.row.set("Guid1C", null);
                    e.row.set("SectionID", null);
                    e.row.set("SectionNumber", null);
                    e.row.set("FloorID", null);
                    e.row.set("FloorNumber", null);

                    CdUIHelper.SetReadOnlyToControls(false, residentialComplex!, project!);
                }
                else {
                    CdCommonHelper.SetFieldToRow(e.row, "RegionID", response.info.RegionID);
                    CdCommonHelper.SetFieldToRow(e.row, "RegionName", response.info.RegionName);
                    CdCommonHelper.SetFieldToRow(e.row, "CityID", response.info.CityID);
                    CdCommonHelper.SetFieldToRow(e.row, "CityName", response.info.CityName);
                    CdCommonHelper.SetFieldToRow(e.row, "ProjectID", response.info.ProjectID);
                    CdCommonHelper.SetFieldToRow(e.row, "ProjectName", response.info.ProjectName);
                    CdCommonHelper.SetFieldToRow(e.row, "ObjectName", response.info.ObjectName);
                    CdCommonHelper.SetFieldToRow(e.row, "LivingComplex", response.info.LivingComplex);
                    CdCommonHelper.SetFieldToRow(e.row, "Guid1C", response.info.Guid1C);
                    CdCommonHelper.SetFieldToRow(e.row, "AddressPost", response.info.AddressPost);
                    CdCommonHelper.SetFieldToRow(e.row, "ResidentialComplexID", response.info.ResidentialComplexID);
                    CdCommonHelper.SetFieldToRow(e.row, "ResidentialComplexName", response.info.ResidentialComplexName);

                    CdUIHelper.SetReadOnlyToControls(false, realEstate!, objectID!, floor!, section!);
                }
            }
        }
        else if (e2.fieldName === "ResidentialComplexID") {
            let projectID = e.row.tryGetField("ProjectID");
            const response = await CdUIHelper.RequestByResidentialComplexOrProject(e2.fieldValue, "ResidentialComplexID");
            if (response && response.info && response.info.ProjectID) {
                projectID = response.info.ProjectID;
                CdCommonHelper.SetFieldToRow(e.row, "ProjectID", response.info.ProjectID);
                CdCommonHelper.SetFieldToRow(e.row, "ProjectName", response.info.ProjectName);
            }
            CdUIHelper.SetReadOnlyToControls(e2.fieldValue == null && projectID == null, realEstate!, objectID!, floor!, section!);
            if (e2.fieldValue !== null) {
                setTimeout(this.SetAutoCompleteEntryValueIfOneAsync, 100, objectID!, e.row, "ObjectID", "ObjectName");
            }

        }
        else if (e2.fieldName === "ProjectID") {
            let residentialComplexID = e.row.tryGetField('ResidentialComplexID');
            const response = await CdUIHelper.RequestByResidentialComplexOrProject(e2.fieldValue, "ProjectID");
            if (response && response.info && response.info.ResidentialComplexID) {
                residentialComplexID = response.info.ResidentialComplexID;
                CdCommonHelper.SetFieldToRow(e.row, "ResidentialComplexID", response.info.ResidentialComplexID);
                CdCommonHelper.SetFieldToRow(e.row, "ResidentialComplexName", response.info.ResidentialComplexName);
            }
            CdUIHelper.SetReadOnlyToControls(e2.fieldValue == null && residentialComplexID == null, realEstate!, objectID!, floor!, section!);
            if (e2.fieldValue !== null) {
                setTimeout(this.SetAutoCompleteEntryValueIfOneAsync, 100, objectID!, e.row, "ObjectID", "ObjectName");
            }
        }
    }
    private static async OutgoingClaimFieldChanges(e2: CardFieldChangedEventArgs, objectID: IControlViewModel | null, project: IControlViewModel | null, e: GridRowEventArgs) {
        if (e2.fieldName === "ResidentialComplexID") {
            CdUIHelper.SetReadOnlyToControls(e2.fieldValue == null, project!);

            e.row.set("RegionID", null);
            e.row.set("RegionName", null);
            e.row.set("CityID", null);
            e.row.set("CityName", null);
            e.row.set("ProjectID", null);
            e.row.set("ProjectName", null);
            e.row.set("LivingComplex", null);
            e.row.set("ObjectName", null);
            e.row.set("ObjectFullName", null);
            e.row.set("ObjectID", null);
            e.row.set("AddressPost", null);
            e.row.set("RealEstateName", null);
            e.row.set("Guid1C", null);
            e.row.set("SectionID", null);
            e.row.set("SectionNumber", null);
            e.row.set("FloorID", null);
            e.row.set("FloorNumber", null);

        }
        else if (e2.fieldName === "ProjectID") {
            CdUIHelper.SetReadOnlyToControls(e2.fieldValue == null, objectID!);
            e.row.set("RegionID", null);
            e.row.set("RegionName", null);
            e.row.set("CityID", null);
            e.row.set("CityName", null);
            e.row.set("LivingComplex", null);
            e.row.set("ObjectName", null);
            e.row.set("ObjectFullName", null);
            e.row.set("ObjectID", null);
            e.row.set("AddressPost", null);
            e.row.set("RealEstateName", null);
            e.row.set("Guid1C", null);
            e.row.set("SectionID", null);
            e.row.set("SectionNumber", null);
            e.row.set("FloorID", null);
            e.row.set("FloorNumber", null);
        }
        else if (e2.fieldName === "ObjectID") {
            if (e2.fieldValue == null) {
                e.row.set("RegionID", null);
                e.row.set("RegionName", null);
                e.row.set("CityID", null);
                e.row.set("CityName", null);
                e.row.set("LivingComplex", null);
                e.row.set("ObjectName", null);
                e.row.set("AddressPost", null);
                e.row.set("RealEstateName", null);
                e.row.set("Guid1C", null);
                e.row.set("SectionID", null);
                e.row.set("SectionNumber", null);
                e.row.set("FloorID", null);
                e.row.set("FloorNumber", null);

            }
            else {
                let objectId = e2.fieldValue;

                const request = new CardRequest();
                request.requestType = CdRequestTypes.GetRegionCityAndProjectByObject;
                request.info["ObjectId"] = createTypedField(objectId, DotNetType.Guid);

                const response = await CardService.instance.request(request);

                await showNotEmpty(response.validationResult.build());
                if (!response.validationResult.isSuccessful) {
                    e.row.set("RegionID", null);
                    e.row.set("RegionName", null);
                    e.row.set("CityID", null);
                    e.row.set("CityName", null);
                    e.row.set("LivingComplex", null);
                    e.row.set("ObjectName", null);
                    e.row.set("AddressPost", null);
                    e.row.set("RealEstateName", null);
                    e.row.set("Guid1C", null);
                    e.row.set("SectionID", null);
                    e.row.set("SectionNumber", null);
                    e.row.set("FloorID", null);
                    e.row.set("FloorNumber", null);
                }
                else {
                    CdCommonHelper.SetFieldToRow(e.row, "RegionID", response.info.RegionID);
                    CdCommonHelper.SetFieldToRow(e.row, "RegionName", response.info.RegionName);
                    CdCommonHelper.SetFieldToRow(e.row, "CityID", response.info.CityID);
                    CdCommonHelper.SetFieldToRow(e.row, "CityName", response.info.CityName);
                    CdCommonHelper.SetFieldToRow(e.row, "ObjectName", response.info.ObjectName);
                    CdCommonHelper.SetFieldToRow(e.row, "LivingComplex", response.info.LivingComplex);
                    CdCommonHelper.SetFieldToRow(e.row, "Guid1C", response.info.Guid1C);
                    CdCommonHelper.SetFieldToRow(e.row, "AddressPost", response.info.AddressPost);
                }
            }
        }
    }

    public static async SetAutoCompleteEntryValueIfOneAsync(controlViewModel: IControlViewModel, row: CardRow, fieldID: string, fieldName: string) {
        var objectAutoCompleteEntryViewModel = controlViewModel as AutoCompleteEntryViewModel;
        var objects = objectAutoCompleteEntryViewModel.itemsSource.findItems(" ", false);
        objects.then((res) => {
            if (res.length == 1) {
                let obj = res[0];
                if (obj.displayFields[0]) {
                    row.set(fieldID, createTypedField(obj.displayFields[0], DotNetType.Guid));
                    row.set(fieldName, createTypedField(obj.displayFields[1], DotNetType.String));
                }
            }
        });

    }

    public static async RequestByResidentialComplexOrProject(requestValue: guid, info: string) {
        if (requestValue == null) return null;
        const request = new CardRequest();
        request.requestType = CdRequestTypes.GetProjectAndLivingComplex;
        request.info[info] = createTypedField(requestValue, DotNetType.Guid);

        const response = await CardService.instance.request(request);

        await showNotEmpty(response.validationResult.build());

        if (response.validationResult.isSuccessful) {
            return response;
        }
        return null;
    }

    public static async RequestByResidentialComplexOrProjectWithNoAvailable(requestValue: guid, info: string) {
        if (requestValue == null) return null;
        const request = new CardRequest();
        request.requestType = CdRequestTypes.GetProjectAndLivingComplexWithNoAvailable;
        request.info[info] = createTypedField(requestValue, DotNetType.Guid);

        const response = await CardService.instance.request(request);

        await showNotEmpty(response.validationResult.build());

        if (response.validationResult.isSuccessful) {
            return response;
        }
        return null;
    }

    public static async CheckCount(context: ICardUIExtensionContext) {
        var card: Card = context.card;
        if (card.tasks.find(x => x.state == CardRowState.Deleted
            && Guid.equals(x.typeId.toLowerCase(), CdFdTaskTypes.PkTechnicalDocumentationAgreementOnRenovationInFRTypeID.toLowerCase())) != null) {
            var task = card.tasks.find(x => x.state == CardRowState.Deleted && Guid.equals(x.typeId, CdFdTaskTypes.PkTechnicalDocumentationAgreementOnRenovationInFRTypeID))
            if (task == null)
                return true;
            var section = task.card.sections.tryGet("PkTaskChanceryComment");
            if (section == null)
                return true;
            var count = section.fields.tryGet("Count");

            if (count == null || count < 0) {
                showError("Поле \"Количество экземпляров на печать для ВПР\" должно быть заполнено неотрицательным целым числом");
                return false;
            }
        }
        return true;
    }

    public static ClearAutoCompleteTableWithMarkingkDeletedItems(context: ICardUIExtensionContext, sectionName) {
        let section = context.model.card.sections.tryGet(sectionName);
        if (section == null) return;
        for (let i = section.rows.length - 1; i >= 0; i--) {
            if (section.rows[i].state === CardRowState.Inserted)
                section.rows.splice(i, 1);
            else section.rows[i].state = CardRowState.Deleted;
        }
    }

    public static ClearAutoCompleteTableWithMarkingkDeletedItems2(card: Card, sectionName) {
        let section = card.sections.tryGet(sectionName);
        if (section == null) return;
        for (let i = section.rows.length - 1; i >= 0; i--) {
            if (section.rows[i].state === CardRowState.Inserted)
                section.rows.splice(i, 1);
            else section.rows[i].state = CardRowState.Deleted;
        }
    }

    public static async FillApprovers(context: ICardUIExtensionContext, rdPropsSection: CardSection) {

        let rdDivisionId = rdPropsSection.fields.tryGet("RdDivisionID");
        let regionId = rdPropsSection.fields.tryGet("RegionID");
        let cityId = rdPropsSection.fields.tryGet("CityID");
        let projectId = rdPropsSection.fields.tryGet("ProjectID");
        let objectId = rdPropsSection.fields.tryGet("ObjectID");
        let isRenovation = rdPropsSection.fields.tryGet("isRenovation");
        if (rdDivisionId == null || regionId == null || cityId == null || projectId == null || objectId == null || isRenovation == null) {
            return;
        }
        const request = new CardRequest();
        request.requestType = CdRequestTypes.GetTechnicalDocumentationApprovers;
        request.info["CardID"] = createTypedField(context.model.card.id, DotNetType.Guid);
        request.info["RdDivisionID"] = createTypedField(rdDivisionId, DotNetType.Guid);
        request.info["ObjectID"] = createTypedField(objectId, DotNetType.Guid);
        request.info["ProjectID"] = createTypedField(projectId, DotNetType.Guid);
        request.info["CityID"] = createTypedField(cityId, DotNetType.Guid);
        request.info["RegionID"] = createTypedField(regionId, DotNetType.Guid);
        request.info["IsRenovation"] = createTypedField(isRenovation, DotNetType.Boolean);
        request.info["AuthorID"] = createTypedField(context.model.card.createdById, DotNetType.Guid);

        const response = await CardService.instance.request(request);
        await showNotEmpty(response.validationResult.build());
        if (!response.validationResult.isSuccessful) return;

        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkDesigners");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkUks");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkProjectGroup");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkContractorsVirtual");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkContractors");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkGip");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkOsp");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkProductDepartmentUsersVirtual");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkSignerOfTechnicalDocumentation");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkTDClerks");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkTDPtoEngineers");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkTDEngineersGroup");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkProjectManagers");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkPIKProjectGroup");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkCustomerProjectTeam");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkMainConstructionControl");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkQualityControlSpecialist");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkMechanicalEngineer");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkElectricalEngineer");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkConstructionControlSSEngineer");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkCustomerServiceEngineerHeatSupply");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkCustomerServiceEngineerVK");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkCustomerServiceEngineerSS");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PkCustomerServiceEngineerEOM");
        CdUIHelper.ClearAutoCompleteTableWithMarkingkDeletedItems(context, "PtoEngineers");

        let uksApprovers = response.info.UksApprovers;
        let projectGroup = response.info.ProjectGroup;
        let contractors = response.info.Contractors;
        let gipApprovers = response.info.GipApprovers;
        let ospApprovers = response.info.OspApprovers;
        let designers = response.info.Designers;
        let usersInTheDepartmentProductRole = response.info.UsersInTheDepartmentProductRole;
        let signersOfTD = response.info.SignersOfTD;
        let tdClerks = response.info.TdClerks;
        let tDPtoEngineers = response.info.TDPtoEngineers;
        let tDEngineersGroup = response.info.TDEngineersGroup;
        let projectManagers = response.info.ProjectManagers;

        let pkQualityControlSpecialist = response.info.PkQualityControlSpecialist;
        let pkTDPtoEngineers = response.info.PkTDPtoEngineers;
        let pkCustomerServiceEngineerHeatSupply = response.info.PkCustomerServiceEngineerHeatSupply;
        let pkElectricalEngineer = response.info.PkElectricalEngineer;
        let pkCustomerServiceEngineerVK = response.info.PkCustomerServiceEngineerVK;
        let pkCustomerServiceEngineerEOM = response.info.PkCustomerServiceEngineerEOM;
        let pkCustomerServiceEngineerSS = response.info.PkCustomerServiceEngineerSS;
        let pkMechanicalEngineer = response.info.PkMechanicalEngineer;
        let pkCustomerProjectTeam = response.info.PkCustomerProjectTeam;
        let pkMainConstructionControl = response.info.PkMainConstructionControl;
        let pkConstructionControlSSEngineer = response.info.PkConstructionControlSSEngineer;
        let pkPIKProjectGroup = response.info.PkPIKProjectGroup;
        let pkGip = response.info.PkGip;

        if (!isRenovation) {
            if (pkQualityControlSpecialist != null) {
                for (let i = 0; i < pkQualityControlSpecialist.length; i++) {
                    let item = pkQualityControlSpecialist[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("RoleID", item.RoleID);
                    row.set("RoleName", item.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkQualityControlSpecialist")!.rows.push(row);
                }
            }

            if (pkTDPtoEngineers != null) {
                for (let i = 0; i < pkTDPtoEngineers.length; i++) {
                    let item = pkTDPtoEngineers[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("RoleID", item.RoleID);
                    row.set("RoleName", item.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkTDPtoEngineers")!.rows.push(row);
                }
            }

            if (pkCustomerServiceEngineerHeatSupply != null) {
                for (let i = 0; i < pkCustomerServiceEngineerHeatSupply.length; i++) {
                    let item = pkCustomerServiceEngineerHeatSupply[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("RoleID", item.RoleID);
                    row.set("RoleName", item.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkCustomerServiceEngineerHeatSupply")!.rows.push(row);
                }
            }

            if (pkElectricalEngineer != null) {
                for (let i = 0; i < pkElectricalEngineer.length; i++) {
                    let item = pkElectricalEngineer[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("RoleID", item.RoleID);
                    row.set("RoleName", item.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkElectricalEngineer")!.rows.push(row);
                }
            }

            if (pkCustomerServiceEngineerVK != null) {
                for (let i = 0; i < pkCustomerServiceEngineerVK.length; i++) {
                    let item = pkCustomerServiceEngineerVK[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("RoleID", item.RoleID);
                    row.set("RoleName", item.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkCustomerServiceEngineerVK")!.rows.push(row);
                }
            }

            if (pkCustomerServiceEngineerEOM != null) {
                for (let i = 0; i < pkCustomerServiceEngineerEOM.length; i++) {
                    let item = pkCustomerServiceEngineerEOM[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("RoleID", item.RoleID);
                    row.set("RoleName", item.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkCustomerServiceEngineerEOM")!.rows.push(row);
                }
            }

            if (pkCustomerServiceEngineerSS != null) {
                for (let i = 0; i < pkCustomerServiceEngineerSS.length; i++) {
                    let item = pkCustomerServiceEngineerSS[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("RoleID", item.RoleID);
                    row.set("RoleName", item.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkCustomerServiceEngineerSS")!.rows.push(row);
                }
            }

            if (pkMechanicalEngineer != null) {
                for (let i = 0; i < pkMechanicalEngineer.length; i++) {
                    let item = pkMechanicalEngineer[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("RoleID", item.RoleID);
                    row.set("RoleName", item.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkMechanicalEngineer")!.rows.push(row);
                }
            }

            if (pkCustomerProjectTeam != null) {
                for (let i = 0; i < pkCustomerProjectTeam.length; i++) {
                    let item = pkCustomerProjectTeam[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("RoleID", item.RoleID);
                    row.set("RoleName", item.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkCustomerProjectTeam")!.rows.push(row);
                }
            }

            if (pkMainConstructionControl != null) {
                for (let i = 0; i < pkMainConstructionControl.length; i++) {
                    let item = pkMainConstructionControl[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("RoleID", item.RoleID);
                    row.set("RoleName", item.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkMainConstructionControl")!.rows.push(row);
                }
            }

            if (pkConstructionControlSSEngineer != null) {
                for (let i = 0; i < pkConstructionControlSSEngineer.length; i++) {
                    let item = pkConstructionControlSSEngineer[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("RoleID", item.RoleID);
                    row.set("RoleName", item.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkConstructionControlSSEngineer")!.rows.push(row);
                }
            }

            if (pkPIKProjectGroup != null) {
                for (let i = 0; i < pkPIKProjectGroup.length; i++) {
                    let item = pkPIKProjectGroup[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("RoleID", item.RoleID);
                    row.set("RoleName", item.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkPIKProjectGroup")!.rows.push(row);
                }
            }

            if (pkGip != null) {
                for (let i = 0; i < pkGip.length; i++) {
                    let item = pkGip[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("Order", createTypedField(i, DotNetType.Int32));
                    row.set("RoleID", item.RoleID);
                    row.set("RoleName", item.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkGip")!.rows.push(row);
                }
            }

            if (contractors != null) {
                for (let i = 0; i < contractors.length; i++) {
                    let item = contractors[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("Order", createTypedField(i, DotNetType.Int32));
                    row.set("RoleID", item.RoleID);
                    row.set("RoleName", item.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkContractors")!.rows.push(row);
                }
            }
        }
        else {
            if (designers != null) {
                for (let i = 0; i < designers.length; i++) {
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("Order", createTypedField(i, DotNetType.Int32));
                    row.set("RoleID", designers[i].RoleID);
                    row.set("RoleName", designers[i].RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkDesigners")!.rows.push(row);
                }
            }

            if (uksApprovers != null) {
                for (let i = 0; i < uksApprovers.length; i++) {
                    let expert = uksApprovers[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("Order", createTypedField(i, DotNetType.Int32));
                    row.set("RoleID", expert.RoleID);
                    row.set("RoleName", expert.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkUks")!.rows.push(row);
                }
            }

            if (gipApprovers != null) {
                for (let i = 0; i < gipApprovers.length; i++) {
                    let expert = gipApprovers[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("Order", createTypedField(i, DotNetType.Int32));
                    row.set("RoleID", expert.RoleID);
                    row.set("RoleName", expert.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkGip")!.rows.push(row);
                }
            }

            if (ospApprovers != null) {
                for (let i = 0; i < ospApprovers.length; i++) {
                    let expert = ospApprovers[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("Order", createTypedField(i, DotNetType.Int32));
                    row.set("RoleID", expert.RoleID);
                    row.set("RoleName", expert.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkOsp")!.rows.push(row);
                }
            }

            if (projectGroup != null) {
                for (let i = 0; i < projectGroup.length; i++) {
                    let expert = projectGroup[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("Order", createTypedField(i, DotNetType.Int32));
                    row.set("RoleID", expert.RoleID);
                    row.set("RoleName", expert.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkProjectGroup")!.rows.push(row);
                }
            }

            if (contractors != null) {
                for (let i = 0; i < contractors.length; i++) {
                    let expert = contractors[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("Order", createTypedField(i, DotNetType.Int32));
                    row.set("RoleID", expert.RoleID);
                    row.set("RoleName", expert.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkContractors")!.rows.push(row);
                }
            }

            if (usersInTheDepartmentProductRole != null) {
                for (let i = 0; i < usersInTheDepartmentProductRole.length; i++) {
                    let expert = usersInTheDepartmentProductRole[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("Order", createTypedField(i, DotNetType.Int32));
                    row.set("RoleID", expert.RoleID);
                    row.set("RoleName", expert.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkProductDepartmentUsersVirtual")!.rows.push(row);
                }
            }

            if (signersOfTD != null) {
                for (let i = 0; i < signersOfTD.length; i++) {
                    let expert = signersOfTD[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("RoleID", expert.RoleID);
                    row.set("RoleName", expert.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkSignerOfTechnicalDocumentation")!.rows.push(row);
                }
            }

            if (tdClerks != null) {
                for (let i = 0; i < tdClerks.length; i++) {
                    let expert = tdClerks[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("RoleID", expert.RoleID);
                    row.set("RoleName", expert.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkTDClerks")!.rows.push(row);
                }
            }

            if (tDPtoEngineers != null) {
                for (let i = 0; i < tDPtoEngineers.length; i++) {
                    let expert = tDPtoEngineers[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("RoleID", expert.RoleID);
                    row.set("RoleName", expert.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkTDPtoEngineers")!.rows.push(row);
                }
            }

            if (tDEngineersGroup != null) {
                for (let i = 0; i < tDEngineersGroup.length; i++) {
                    let expert = tDEngineersGroup[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("RoleID", expert.RoleID);
                    row.set("RoleName", expert.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkTDEngineersGroup")!.rows.push(row);
                }
            }
            if (projectManagers != null) {
                for (let i = 0; i < projectManagers.length; i++) {
                    let expert = projectManagers[i];
                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    row.set("RoleID", expert.RoleID);
                    row.set("RoleName", expert.RoleName);
                    row.state = CardRowState.Inserted;
                    context.model.card.sections.get("PkProjectManagers")!.rows.push(row);
                }
            }
        }
    }

    public static FillingUpVirtualInfoArDocumentIDP(context: ICardUIExtensionContext) {
        const adiSection = context.model.card.sections.tryGet('ArchiveDocumentIDP');
        if (adiSection == null) return;

        adiSection.fields.fieldChanged.add(async e => {
            if (e.fieldName === "ContractID") {
                let contractID = e.fieldValue;

                if (contractID == null) {
                    // Удаление даты договора
                    adiSection.fields.set("ContractDate", null);

                    // Удаление существующих виртуальных записей в таблице Объекты
                    const polSectionRows = context.model.card.sections.tryGet('PkObjectList')!.rows;
                    if (polSectionRows != null) {
                        for (let i = polSectionRows.length - 1; i >= 0; i--) {
                            if (polSectionRows[i].tryGet("IsVirtual", false) === true) {

                                if (polSectionRows[i].state === CardRowState.None) {
                                    polSectionRows[i].state = CardRowState.Deleted;
                                }
                                else {
                                    polSectionRows.splice(i, 1);
                                }
                            }
                        }
                    }

                    // Удаление существующих виртуальных записей в таблице Контрагенты
                    const ardapSectionRows = context.model.card.sections.tryGet('ArDocumentsIDPPartners')!.rows;
                    if (ardapSectionRows != null) {
                        for (let i = ardapSectionRows.length - 1; i >= 0; i--) {
                            if (ardapSectionRows[i].tryGet("IsVirtual", false) === true) {

                                if (ardapSectionRows[i].state === CardRowState.None) {
                                    ardapSectionRows[i].state = CardRowState.Deleted;
                                }
                                else {
                                    ardapSectionRows.splice(i, 1);
                                }
                            }
                        }
                    }
                }
                else {
                    const request = new CardRequest();
                    request.requestType = CdRequestTypes.ArDocumentIDPVirtualInfo;
                    request.info["TypeFlag"] = createTypedField(0, DotNetType.Int32);
                    request.info["ContractID"] = createTypedField(contractID, DotNetType.Guid);

                    const response = await CardService.instance.request(request);

                    await showNotEmpty(response.validationResult.build());
                    if (!response.validationResult.isSuccessful) return;

                    // Заполнение Даты договора
                    adiSection.fields.set("ContractDate", response.info!.ContractDate);

                    const ardapSection = context.model.card.sections.tryGet('ArDocumentsIDPPartners');
                    if (ardapSection != null) {
                        // Удаление существующих виртуальных записей в таблице Контрагенты
                        const ardapSectionRows = ardapSection.rows;
                        if (ardapSectionRows != null) {
                            for (let i = ardapSectionRows.length - 1; i >= 0; i--) {
                                if (ardapSectionRows[i].tryGet("IsVirtual", false) === true) {
                                    ardapSectionRows[i].state = CardRowState.Deleted;
                                }
                            }
                        }

                        if (response.info!.PartnerInfo!) {
                            for (let partner of response.info.PartnerInfo) {
                                let row = new CardRow();
                                row.set("Category", partner.Category);
                                row.set("INN", partner.INN);
                                row.set("Partner", partner.FullName);
                                row.set("PartnerExternalID", partner.ExtID);
                                row.set("PartnerFullName", partner.FullName);
                                row.set("PartnerID", createTypedField(Guid.newGuid(), DotNetType.Guid));
                                row.set("PartnerINN", partner.INN);
                                row.set("IsVirtual", createTypedField(true, DotNetType.Boolean));
                                row.rowId = Guid.newGuid();
                                row.state = CardRowState.Inserted;
                                ardapSection.rows.push(row);
                            }
                        }
                    }

                    const olSection = context.model.card.sections.tryGet('PkObjectList');
                    if (olSection != null) {
                        // Удаление существующих виртуальных записей
                        const polSectionRows = olSection.rows;
                        if (polSectionRows != null) {
                            for (let i = polSectionRows.length - 1; i >= 0; i--) {
                                if (polSectionRows[i].tryGet("IsVirtual", false) === true) {
                                    polSectionRows.splice(i, 1);
                                }
                            }
                        }

                        if (response.info!.ObjectInfo!) {
                            for (let obj of response.info.ObjectInfo) {
                                let row = new CardRow();
                                row.set("AddressPost", obj.AddressPostValue);
                                row.set("CityID", obj.CityIDValue);
                                row.set("CityName", obj.CityNameValue);
                                row.set("Guid1C", obj.Guid1CValue);
                                row.set("LivingComplex", obj.LivingComplexValue);
                                row.set("ObjectID", obj.ObjectIDValue);
                                row.set("ObjectName", obj.ObjectNameValue);
                                row.set("ProjectID", obj.ProjectIDValue);
                                row.set("ProjectName", obj.ProjectNameValue);
                                row.set("RealEstateID", obj.RealEstateIDValue);
                                row.set("RealEstateName", obj.RealEstateNameValue);
                                row.set("RegionID", obj.RegionIDValue);
                                row.set("RegionName", obj.RegionNameValue);
                                row.set("ResidentialComplexID", obj.ResidentialComplexIDValue);
                                row.set("ResidentialComplexName", obj.ResidentialComplexNameValue);
                                row.set("IsVirtual", createTypedField(true, DotNetType.Boolean));
                                row.rowId = Guid.newGuid();
                                row.state = CardRowState.Inserted;
                                olSection.rows.push(row);
                            }
                        }
                    }
                }
            }
            else if (e.fieldName === "DocumentIDPTypeID") {
                if (e.fieldValue == null) {
                    adiSection.fields.set("KindGroupingID", null);
                    adiSection.fields.set("KindGroupingArchiveSection", null);
                }
                else {
                    let typeID = e.fieldValue;

                    const request = new CardRequest();
                    request.requestType = CdRequestTypes.ArDocumentIDPVirtualInfo;
                    request.info["TypeFlag"] = createTypedField(1, DotNetType.Int32);
                    request.info["TypeID"] = createTypedField(typeID, DotNetType.Guid);

                    const response = await CardService.instance.request(request);

                    await showNotEmpty(response.validationResult.build());
                    if (!response.validationResult.isSuccessful) return;

                    // Заполнение Группировки вида документа
                    CdCommonHelper.SetFieldToSection(adiSection, "KindGroupingID", response.info.GroupingID);
                    CdCommonHelper.SetFieldToSection(adiSection, "KindGroupingArchiveSection", response.info.GroupingName);
                }
            }
        });
    }

    public static FillingUpVehaBOP(context: ICardUIExtensionContext) {
        const adiSection = context.model.card.sections.tryGet('ArchiveDocumentIDP');
        if (adiSection == null) return;
        adiSection.fields.fieldChanged.add(async e => {
            if (e.fieldName === "DocumentIDPTypeID") {
                let documentKindID = e.fieldValue;
                if (documentKindID == null || documentKindID === Guid.empty) {
                    adiSection.fields.set("VehaBOPName", null);
                    adiSection.fields.set("VehaBOPID", null);
                    adiSection.fields.set("VehaBOPCode", null);
                    adiSection.fields.set("DocumentIDPTypeID", null);
                    adiSection.fields.set("DocumentIDPTypeDocumentKind", null);
                }
                else {
                    const request = new CardRequest();
                    request.requestType = CdRequestTypes.ArDocumentKind;
                    request.info["DocumentKindID"] = createTypedField(documentKindID, DotNetType.Guid);

                    const response = await CardService.instance.request(request);

                    await showNotEmpty(response.validationResult.build());
                    if (!response.validationResult.isSuccessful) {
                        adiSection.fields.set("VehaBOPName", null);
                        adiSection.fields.set("VehaBOPID", null);
                        adiSection.fields.set("VehaBOPCode", null);
                        adiSection.fields.set("DocumentIDPTypeID", null);
                        adiSection.fields.set("DocumentIDPTypeDocumentKind", null);
                    }
                    else {
                        if (response.info != null && response.info.VehaBopName != null && response.info.VehaBopCode) {
                            CdCommonHelper.SetFieldToSection(adiSection, "VehaBOPName", response.info.VehaBopName);
                            CdCommonHelper.SetFieldToSection(adiSection, "VehaBOPCode", response.info.VehaBopCode);
                            //let vehaId = response.info.VehaBopId as guid | null;
                            //vehaId = Guid.newGuid();
                            if (response.info.VehaBopId == null)
                                CdCommonHelper.SetFieldToSection(adiSection, "VehaBOPID", createTypedField(Guid.newGuid(), DotNetType.Guid));
                            else
                                CdCommonHelper.SetFieldToSection(adiSection, "VehaBOPID", response.info.VehaBopId);

                        }
                        else {
                            adiSection.fields.set("VehaBOPName", null);
                            adiSection.fields.set("VehaBOPCode", null);
                            adiSection.fields.set("VehaBOPID", null);
                        }
                    }
                }
            }
        });
    }

    public static GetUIControl<T extends ControlViewModelBase>(context: ICardUIExtensionContext, controlName: string): T | null {
        let viewModelBase = context.model.controls.get(controlName);
        if (viewModelBase) {
            let result = viewModelBase as T;
            return result;
        }
        return null;
    }

    public static GetUIControlFromModel<T extends IControlViewModel>(model: ICardModel, controlName: string): T | null {
        let viewModelBase = model.controls.get(controlName);
        if (viewModelBase) {
            let result = viewModelBase as T;
            return result;
        }
        return null;
    }

    public static GetUIControlFromForm<T extends IControlViewModel>(form: IFormViewModel, controlName?: string | null): T | null {
        // если название контрола передавалось, значит проверяем его при поиске
        const isCheckControlName = controlName != null;

        // пробегаемся по переданной коллекции блоков
        for (const block of form.blocks) {
            // пробегаемся по контролам блока
            for (const control of block.controls) {
                // проверка названия контрола
                if (isCheckControlName && control.name !== controlName) {
                    continue;
                }

                // проверка типа контрола
                const result = control as T;
                if (result != null) {
                    return result;
                }
            }
        }

        return null;
    }

    /** Проверка наличия контента файла */
    public static async CheckContentFileAsync(card: Card) {
        let fileNames = '';
        for (let i = 0; i < card.files.length; i++) {
            let file = card.files[i];
            if (file.categoryId === null ||
                file.categoryId === ChFileCategories.ElectronicSignatures.id!.toLowerCase() ||
                file.name.indexOf(CdGeneralDocumentationClientHelper.PdfForPrint) > 0) {
                continue;
            }

            if (file.state === CardFileState.Replaced) {
                showMessage('Файлы были обновлены.\nПожалуйста, сохраните карточку перед тем как продолжить.');
                return false;
            }

            if (!file.lastVersion) {
                continue;
            }

            const getFileContentRequest = new CardGetFileContentRequest();
            getFileContentRequest.cardId = card.id;
            getFileContentRequest.cardTypeId = card.typeId;
            getFileContentRequest.cardTypeName = card.typeName;
            getFileContentRequest.fileId = file.rowId;
            getFileContentRequest.fileName = file.name;
            getFileContentRequest.versionRowId = file.versionRowId;
            getFileContentRequest.fileTypeId = file.typeId;
            getFileContentRequest.fileTypeName = file.typeName;

            const getFileContentResponse = await CardService.instance.getFileContent(getFileContentRequest);

            if (getFileContentResponse.validationResult.isSuccessful &&
                getFileContentResponse.content != null &&
                getFileContentResponse.size > 0) {
                continue;
            }

            fileNames = '\n' + file.name;
        }
        if (fileNames.length > 0) {
            showError('Некоторые приложенные файлы загрузились неправильно:' + fileNames + '\n\nПожалуйста, обновите их и сохраните карточку перед тем как продолжить.\n');
            return false;
        }
        return true;
    }

    /** Чистка строк секции. */
    public static ClearSectionRows(
        section: CardSection) {
        // проверяем тип секции
        if (section.type != CardSectionType.Table) {
            return;
        }

        // пробегаемся по строкам
        for (let i = section.rows.length - 1; i >= 0; i--) {
            // получаем строку
            const row = section.rows[i];

            // если строка создавалась, значит ее еще нет физически
            if (row.state == CardRowState.Inserted) {
                // просто удаляем
                section.rows.remove(row);

                // смотрим дальше
                continue;
            }

            // иначе помечаем строку как удаленную
            row.state = CardRowState.Deleted;
        }
    }

    /** Запрет ввода символов из регулярного выражения. */
    public static ForbiddingCharacterInput(control: TextBoxViewModel, regExp: RegExp) {
        control.keyDown.addWithDispose((e) => {
            // проверяем входит ли нажатый символ в переданноу регулярное выражение
            if (e.event.key.search(regExp) < 0) {
                return;
            }

            // если входит, тогда не даем ввести, возвращаемся к предыдущему значению
            e.event.preventDefault();
        });
    }

    /// <summary>
    /// Разрешить редактирование КСД созданных в ЕСУД
    /// TES-8640 + TES-8902
    /// </summary>
    public static AllowEditESUDDocs(context: ICardUIExtensionContext, session: IUserSession, documentSections: DocumentSections) {

        if (!this.IsAllowEditESUDDocs(context?.card)) {
            return;
        }

        if (!session.isAdmin) {
            return;
        }

        switch (documentSections) {
            case DocumentSections.ContractArticleIdp:
                this.AllowEditForContractArticleIdp(context);
                break;
            case DocumentSections.ArContractPartnersTable:
                this.AllowEditForArContractPartnersTable(context);
                break;
        }

    }

    /// <summary>
    /// TES-8640
    /// </summary>
    private static AllowEditForContractArticleIdp(context: ICardUIExtensionContext) {

        const articles = context.model.controls.get('ContractArticleIdp') as GridViewModel;

        articles!.rowInitializing.add(e => {
            if (e.action == GridRowAction.Opening) {
                let objectID = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "Object");
                let project = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "Project");
                let stageName = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "StageNameArticleControl");
                let paymentTerm = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "PaymentTermArticleControl");
                let percentPrepayment = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "PercentPrepaymentArticleControl");
                let vatRate = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "VatRateCommon");

                CdUIHelper.SetReadOnlyToControls(false, objectID!, project!, stageName!, paymentTerm!, percentPrepayment!, vatRate!);
            }
        });

    }

    /// <summary>
    /// TES-8902
    /// </summary>
    private static AllowEditForArContractPartnersTable(context: ICardUIExtensionContext) {

        const arContractsPartnerTable = context.model.controls.get('ArContractPartnersTable') as GridViewModel;

        arContractsPartnerTable!.rowInitializing.add(e => {
            if (e.action == GridRowAction.Opening) {
                let partnerPerformer = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "PartnerPerformer");
                let partnersPartner = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "PartnersKCKControl");
                let partnerAccountant = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "PartnerAccountant");
                let partnerSigned = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "PartnerSigned");
                let partnerContractCategory = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "ContractCategoryControl");
                let partnerDepartment = CdUIHelper.GetUIControlFromModel<IControlViewModel>(e.rowModel!, "PartnerDepartment");

                CdUIHelper.SetReadOnlyToControls(false, partnerPerformer!, partnersPartner!, partnerAccountant!, partnerSigned!, partnerContractCategory!, partnerDepartment!);
            }
        });

    }

    /// <summary>
    /// Проверка условий возможности редактирования КСД из ЕСУД
    /// </summary>
    public static IsAllowEditESUDDocs(card: Card) {
        return this.IsDocFromESUD(card) && this.IsActiveOrFulfilled(card);
    }

    /// <summary>
    /// Проверка на состояние документа
    /// </summary>
    public static IsActiveOrFulfilled(card: Card) {
        let pkdci = card.sections.tryGet('PkDocumentCommonInfo');

        return pkdci
            && (pkdci.fields?.tryGet('StateID') == CdDocStates.Active.id
                || pkdci.fields?.tryGet('StateID') == CdDocStates.Fulfilled.id);
    }

    /// <summary>
    /// Проверка, что КСД создан в ЕСУД, не является судебкой и не из CRM
    /// </summary>
    private static IsDocFromESUD(card: Card) {
        let acu = card.sections.tryGet('ArContractsUser');
        let adc = card.sections.tryGet('ArDocsConstructor');

        return acu
            && adc
            // Заполнен реквизит ID MDS
            && acu.fields?.tryGet('ExtID')
            // Не заполнен реквизит GuidCRM
            && !acu.fields?.tryGet('GuidCRM')
            // Не заполнен реквизит CourtCasePaymentDocGuid1C
            && !adc.fields?.tryGet('CourtCasePaymentDocGuid1C');
    }
}